import OperationsAvailableTrucks from "../../components/Operations/AvailableTrucks/OperationsAvailableTrucks";

const OperationsAvailableTrucksPage = () => {
  return <OperationsAvailableTrucks />;
};

export default OperationsAvailableTrucksPage;
